import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Copyright from '../../commons/Copyright'
import styled from 'styled-components'
import { height } from '@mui/system'
import Card from '@mui/material/Card'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'
import { userService as service, userService } from '../../../services'
import { useNavigate } from 'react-router-dom'
import { Grid } from '@mui/material'
import { resolveLoginError } from './loginError'

const loginData = {
    email: '',
    pass: '',
}

export default function Login() {
    const { t, i18n } = useTranslation()
    const [data, setData] = useState({ ...loginData })
    const [errorKind, setErrorKind] = useState<'credentials' | 'technical' | null>(null)
    const navigate = useNavigate()

    const onChange = (event) => {
        let name = event.target.name
        let value = event.target.value

        setData((currentValueform) => ({ ...currentValueform, [name]: value }))
    }

    const doLogin = () => {
        setErrorKind(null)
        userService.login(data, (result, error) => {
            if (result) {
                if (!result.user.permissions.includes('SUSCRIPTION')) {
                    // Credenciales validas pero rol no permitido en este panel (fuera del alcance del bug).
                    setErrorKind('credentials')
                } else {
                    localStorage.setItem('tokensus', result.token)
                    localStorage.setItem('usersus', JSON.stringify(result.user))
                    navigate('/dashboard')
                }
            } else {
                // Decidir el copy por status HTTP / ausencia de respuesta, no por un "ha fallado" generico.
                setErrorKind(resolveLoginError(error?.status, error?.noResponse))
            }
        })
    }

    const onSubmit = (evt) => {
        evt.preventDefault()
        doLogin()
        return false
    }

    return (
        <Main>
            <CardLongin>
                <GridPanel container>
                    <GridFormLogin sm={6} xs={12}></GridFormLogin>
                    <GridForm sm={6} xs={12}>
                        <FormStyle method="post" onSubmit={onSubmit}>
                            <DivForm>
                                <Typography
                                    variant="body2"
                                    color="textPrimary"
                                    align="center"
                                    style={{
                                        color: '#94d63e',
                                        fontSize: '1.5em',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    {t('login.title')}
                                </Typography>
                                <TextFieldForm
                                    value={data.email}
                                    id="email"
                                    name="email"
                                    required
                                    variant="standard"
                                    label={t('login.email')}
                                    onChange={onChange}
                                    type="email"
                                />
                                <br />
                                <TextFieldForm
                                    value={data.pass}
                                    id="email"
                                    name="pass"
                                    required
                                    type="password"
                                    variant="standard"
                                    label={t('login.pass')}
                                    onChange={onChange}
                                />
                                <br />
                                {errorKind === 'credentials' && (
                                    <Typography
                                        variant="body2"
                                        color="error"
                                        align="center"
                                    >
                                        {t('login.error.invalidCredentials')}
                                    </Typography>
                                )}
                                {errorKind === 'technical' && (
                                    <>
                                        <Typography
                                            variant="body2"
                                            color="error"
                                            align="center"
                                        >
                                            {t('login.error.serviceUnavailable')}
                                        </Typography>
                                        <ButtonForm
                                            variant="outlined"
                                            color="primary"
                                            onClick={doLogin}
                                        >
                                            {t('login.retry')}
                                        </ButtonForm>
                                    </>
                                )}
                                <ButtonForm
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                >
                                    {t('login.login')}
                                </ButtonForm>
                                <br />
                                {errorKind !== 'technical' && (
                                    <Link
                                        href="/recoverypass"
                                        underline="hover"
                                        color="primary"
                                    >
                                        {t('login.recovery')}
                                    </Link>
                                )}
                                <br />
                            </DivForm>
                        </FormStyle>
                        <Copyright />
                    </GridForm>
                </GridPanel>
            </CardLongin>
        </Main>
    )
}

const GridFormLogin = styled(Grid)`
    min-height: 5em;
    background: url('/loginform.png');
    background-size: cover;
    background-repeat: no-repeat;
`
const GridPanel = styled(Grid)`
    background: white;
    min-height: 35em;
    border-radius: 20px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
    overflow: hidden;
    border: 1px solid #ccc;
`

const GridForm = styled(Grid)`
    display: flex;
    align-items: center;
    flex-direction: column !important;
    justify-content: center;
    align-content: center;
    align-items: center;
`

const FormStyle = styled.form`
    display: flex;
    justify-content: center;
`

const CardLongin = styled(Card)`
    width: 800px;
    max-width: 85%;
    margin: auto;
    padding: 0em;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: none !important;
    border: none !important;
    box-shadow: none !important;
`

const TextFieldForm = styled(TextField)`
    margin-bottom: 20px;
`
const ButtonForm = styled(Button)`
    width: fit-content;
    color: white !important;
    padding: 7px 40px;
`

const Main = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    background: white;
`

const ImgLogo = styled.img`
    width: 200px;
    max-width: 40%;
`

const DivForm = styled.div`
    display: flex;
    flex-direction: column;
    width: 400px;
    max-width: 90%;
    row-gap: 10px;
    padding: 0 1em;
    align-items: center;

    > .MuiFormControl-root {
        width: 100%;
    }

    @media (max-width: 767px) {
        width: 90%;
    }
`
